export const CREATE_CASH_PAYMENT  = 'CREATE_CASH_PAYMENT';
export const GET_CASH_PAYMENTS  = 'GET_CASH_PAYMENTS';
export const CASH_PAYMENT_REQUEST  = 'CASH_PAYMENT_REQUEST';
export const DELETE_CASH_PAYMENT  = 'DELETE_CASH_PAYMENT';
export const UPDATE_CASH_PAYMENT  = 'UPDATE_CASH_PAYMENT';
export const CASH_PAYMENT_REQUEST_SUCCESS  = 'CASH_PAYMENT_REQUEST_SUCCESS';
export const CASH_PAYMENT_REQUEST_FAILURE  = 'CASH_PAYMENT_REQUEST_FAILURE';
export const GET_CASH_PAYMENTS_PAGE  = 'GET_CASH_PAYMENTS_PAGE';